<template>
  <button type="button" class="code" :class="[size]" @click="handleCopy">
    <Transition name="slide-up-down">
      <p v-show="isCopied" class="code-copied">Code copié</p>
    </Transition>
    <span v-for="(char, index) in code" :key="index">{{ char }}</span>
  </button>
</template>
<script setup lang="ts">
interface Props {
  code: string;
  size?: string;
}
const props = defineProps({
  code: null,
  size: null
});
const codelength = computed(() => {
  return props.code.length;
});
const widthcss = computed(() => {
  if (props.code.length >= 8) {
    return `3.7rem`;
  } else {
    return `5rem`;
  }
});
const { copy } = useClipboard({ source: props.code });
const isCopied = ref(false);
const handleCopy = () => {
  copy();
  isCopied.value = true;
  setTimeout(() => {
    isCopied.value = false;
  }, 1500);
};
</script>
<style lang="scss" scoped>
.code {
  display: grid;
  position: relative;
  grid-template-columns: repeat(v-bind(codelength), auto);
  justify-content: space-between;
  width: 100%;
  &.normal {
    @include font('n', 500);
  }
  &.small {
    @include font('s', 400);
  }
  &.medium {
    @include font('m', 700);
  }
  &.x-large {
    @include font('xl', 700);
  }
  &.xx-large {
    @include font('xxl', 700);
  }
  span {
    display: block;
    width: v-bind(widthcss);
    padding: 0.5rem;
    transition: color 0.2s $ease-in-out-quad, border 0.2s $ease-in-out-quad;
    border: 0.1rem solid var(--color_neutral_100);
    text-align: center;
    cursor: pointer;
    @include stroke('n', 'n');
  }
  &:hover span {
    border: 0.1rem solid var(--color_primary);
    color: var(--color_primary);
  }
}
.code-copied {
  position: absolute;
  z-index: 2;
  top: 50%;
  left: 50%;
  padding: 0.5rem 0.8rem;
  transform: translate(-50%, -50%);
  @include stroke('0', 'n');

  background-color: #808080e8;
  color: white;
}
.slide-up-down-enter-active {
  transition: transform 200ms $ease-out-expo, opacity 100ms $ease-out-quad 50ms;
}
.slide-up-down-leave-active {
  transition: transform 200ms $ease-in-circ, opacity 100ms $ease-in-quad 100ms;
}

.slide-up-down-enter-from {
  transform: translate(-50%, -150%) scale(0.9);
  opacity: 0;
}
.slide-up-down-leave-to {
  transform: translate(-50%, 50%) scale(0.9);
  opacity: 0;
}
</style>
